import { FlagSet as _FlagSet } from './src/feature-flag-client';

export type FlagSet = _FlagSet;
export {
  featureFlagClient,
  FX3_EVALUATIONS_FLAG,
} from './src/feature-flag-client';
export { useFeatureFlag } from './src/useFeatureFlag';
export { fx3ConsistencyChecker } from './src/fx3ConsistencyChecker';
